module.exports = __webpack_public_path__ + "static/media/hbb_grid_7.265267f2.png";